export { GlobalStyle as default } from './GlobalStyle.style';
